/* ולידציה לטפסי יצירת הקשר של Shopify. אם הטופס תקין — לא מתערבים בשליחה,
   כדי לא לשבור את הגנת הבוטים של Shopify שמיירטת את ה-submit. */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setErr(input, on, msg) {
    input.setAttribute('aria-invalid', on ? 'true' : 'false');
    var e = document.querySelector('.err[data-for="' + input.id + '"]');
    if (e) { e.classList.toggle('is-on', on); if (msg) e.textContent = msg; }
  }
  function validPhone(v) {
    var d = v.replace(/[^\d+]/g, '');
    return /^0\d{8,9}$/.test(d) || /^\+?972\d{8,9}$/.test(d);
  }
  function validate(form) {
    var ok = true, first = null;
    $$('input, select, textarea', form).forEach(function (el) {
      if (el.type === 'hidden' || el.type === 'submit') return;
      var v = (el.value || '').trim(), bad = false, msg = '';
      if (el.hasAttribute('required') && !v) { bad = true; msg = 'שדה חובה'; }
      else if (el.type === 'tel' && v && !validPhone(v)) { bad = true; msg = 'מספר טלפון לא תקין'; }
      else if (el.type === 'email' && v && !EMAIL.test(v)) { bad = true; msg = 'כתובת אימייל לא תקינה'; }
      setErr(el, bad, msg);
      if (bad) { ok = false; if (!first) first = el; }
    });
    if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return ok;
  }

  $$('form.nm-validate').forEach(function (form) {
    form.setAttribute('novalidate', 'novalidate');
    form.addEventListener('submit', function (e) { if (!validate(form)) e.preventDefault(); });
  });
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el.matches && el.matches('input, select, textarea') && el.getAttribute('aria-invalid') === 'true' && (el.value || '').trim()) setErr(el, false);
  });

  // הגעה מעמוד מוצר / מחיפוש לפי מידה — ממלאים את ההערות
  var ref = new URLSearchParams(location.search).get('ref');
  if (ref) {
    var notes = document.getElementById('cf-notes') || document.getElementById('k-msg');
    if (notes && !notes.value) notes.value = 'בהמשך ל: ' + ref + '\n';
  }
})();
